console.log('✅ select-language-top.js loaded successfully!');

// Efficient top-level imports for frequently used core modules
import { APP_CONFIG } from '../../js/config.js';
import { registerEventListenerToAttach } from '../../js/to-attach-event-listener-registry.js';
import { addListenerViaCurrentlyAttachedListenersRegistry } from '../../js/currently-attached-listener-registry.js';
import { appState, setAppStateValueByKey, getArrowToggleDownIconSVG } from '../../js/state.js';
import { updateLanguageInURL } from '../../js/router.js';

import { loadTextTranslations } from '../../js/translator.js';
import { initLinksTranslator } from '../../js/router-routes-manager.js';

let _tempTextTranslator = null;
export async function initTempTextTranslator(lang) {
  _tempTextTranslator = await loadTextTranslations(lang);
}

let _tempLinksTranslator = null;
export async function initTempLinksTranslator(lang) {
  _tempLinksTranslator = await initLinksTranslator(lang);
}

const lang = appState.SiteLanguageCookie;

export async function buildComponentSelectLanguageSidebar() {
  console.log(`🔄 Building Component: SelectLanguageTop - lang: ${lang}`);

  try {
    await initTempTextTranslator(lang);
    await initTempLinksTranslator(lang);

    const { keySelectLanguage: lblSelectLanguage } = _tempTextTranslator;

    //const {
    //    keySubcategories: linkSubcategories,

    //}
    //    = _tempLinksTranslator;

    // <img src="${languageIcon}" class="new-language-globe-icon" width="20" height="20" alt="Select Language" />
    // <img src="${dropdownIcon}" class="new-language-dropdown-icon" width="20" height="20" />
    // const downIconSVG = getArrowToggleDownIconSVG("new-language-dropdown-icon", 20);

    // Get language label from code
    const getLanguageLabel = code => {
      const lang = APP_CONFIG.VALID_LANGUAGES.find(lang => lang.code === code);
      return lang ? lang.name : 'English (UK)';
    };

    const languageLabel = getLanguageLabel(lang);
    const imgSrcForIcons = `${APP_CONFIG.IMAGES_BASE_URL}imgs/icons/svg/`;
    const languageIcon = `${imgSrcForIcons}language11.svg`;
    const dropdownIcon = `${imgSrcForIcons}arrow-toggle-down.svg`;

    // Generate language options dynamically
    const optionsHTML = APP_CONFIG.VALID_LANGUAGES.map(
      lang =>
        `<option class="dropbtnSelectSiteLanguage-content-label-mobile" value="${lang.code}">${lang.name}</option>`
    ).join('');

    //<svg viewBox="0 0 24 24" class="new-language-globe-icon" width="20" height="20" role="img" xmlns="http://www.w3.org/2000/svg" aria-labelledby="languageIconTitle" stroke="#000000" stroke-width="1" stroke-linecap="square" stroke-linejoin="miter" fill="none" color="#000000">
    //    <title id="languageIconTitle">Language</title>
    //    <circle cx="12" cy="12" r="10" />
    //    <path stroke-linecap="round" d="M12,22 C14.6666667,19.5757576 16,16.2424242 16,12 C16,7.75757576 14.6666667,4.42424242 12,2 C9.33333333,4.42424242 8,7.75757576 8,12 C8,16.2424242 9.33333333,19.5757576 12,22 Z" />
    //    <path stroke-linecap="round" d="M2.5 9L21.5 9M2.5 15L21.5 15" />
    //</svg>

    // Generate the HTML structure

    const html = `

         <div id="btnSideBarNavDropdown-btn-select-language" class="SideBarNavDropdown-btn-select-language" data-dropdown-id="shipToSidebarDropdown">


         <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 512 512" fill="none" stroke="#000000" stroke-width="32" stroke-linecap="round" stroke-linejoin="round" class="dropbtnSelectSiteLanguage-icon">
      <title>Language Icon</title>
      <line x1="48" y1="112" x2="336" y2="112"/>
      <line x1="192" y1="64" x2="192" y2="112"/>
      <polyline points="272 448 368 224 464 448"/>
      <line x1="301.5" y1="384" x2="434.5" y2="384"/>
      <path d="M281.3,112S257,206,199,277,80,384,80,384"/>
      <path d="M256,336s-35-27-72-75-56-85-56-85"/>
    </svg>


     

   <label class="sideBarLanguageLabel"> ${lblSelectLanguage}</label>
      
      <svg fill="#555" height="20px" width="20px" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" class="NewNavSidePanelDropdownFa-caret-down">
      <path d="M13.708 6.29A1.006 1.006 0 0 0 13 6H5.005A1 1 0 0 0 4.3 7.71l4 4a1.013 1.013 0 0 0 1.42 0l4-4a1.01 1.01 0 0 0-.013-1.42z"></path>
    </svg>
      </div>


      <div class="NewNavSidePanelDropdown-container" style="display:none;">

      <div class="divSideLanguageWrapper">

  <br />
  

     ${optionsHTML}

     
    <br />
    


     </div>

      </div>
        
        `;

    //    const html = `
    //        <div class="divTopLanguageWrapper" tabindex="0">
    //            <div class="divTopLanguageWrapper-Button">
    //                <button id="btnSelectLanguage" class="button" title="Select Language">
    //                    <div class="new-language-container">

    //                    <svg viewBox="0 0 24 24" class="new-language-globe-icon" width="20" height="20" role="img" xmlns="http://www.w3.org/2000/svg" aria-labelledby="languageIconTitle" stroke="#000000" stroke-width="1" stroke-linecap="square" stroke-linejoin="miter" fill="none" color="#000000">
    //  <title id="languageIconTitle">Language</title>
    //  <circle cx="12" cy="12" r="10"/>
    //  <path stroke-linecap="round" d="M12,22 C14.6666667,19.5757576 16,16.2424242 16,12 C16,7.75757576 14.6666667,4.42424242 12,2 C9.33333333,4.42424242 8,7.75757576 8,12 C8,16.2424242 9.33333333,19.5757576 12,22 Z"/>
    //  <path stroke-linecap="round" d="M2.5 9L21.5 9M2.5 15L21.5 15"/>
    //</svg>

    //                        <div class="new-language-label">${languageLabel}</div>
    //                      <svg fill="#555" height="20px" width="20px" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" class="new-language-dropdown-icon">
    //  <path d="M13.708 6.29A1.006 1.006 0 0 0 13 6H5.005A1 1 0 0 0 4.3 7.71l4 4a1.013 1.013 0 0 0 1.42 0l4-4a1.01 1.01 0 0 0-.013-1.42z"></path>
    //</svg>
    //                    </div>
    //                </button>
    //            </div>
    //            <div id="dropDownSelectSiteLanguage" class="dropbtnSelectSiteLanguage-content" style="display: none;">
    //                ${optionsHTML}
    //            </div>
    //        </div>`;

    console.log('✅ SelectLanguageTop built successfully.');

    // Register the event listener only when the component is built
    registerEventListenerToAttach(async () => initbuildComponentSelectLanguageSidebar());

    return html;
  } catch (err) {
    console.error('❌ Error building SelectLanguageTop:', err);
    return '<div>Error loading language selector</div>';
  }
}

export async function initbuildComponentSelectLanguageSidebar() {
  try {
    let isDropdownOpen = false;

    const button = document.getElementById('btnSideBarNavDropdown-btn-select-language');
    if (!button) return;

    const onLanguageToggleClick = async () => {
      button.classList.toggle('NewNavSidePanelDropdownActive');
      const dropdownContent = button.nextElementSibling;

      isDropdownOpen = !isDropdownOpen;
      dropdownContent.style.display = isDropdownOpen ? 'block' : 'none';
    };

    button.removeEventListener('click', onLanguageToggleClick);
    button.addEventListener('click', onLanguageToggleClick);

    const dropdown = button.nextElementSibling;
    const options = dropdown.querySelectorAll('.dropbtnSelectSiteLanguage-content-label-mobile');

    options.forEach(option => {
      const onOptionClick = async event => {
        const newLang = event.target.value;
        if (newLang) {
          await applyLanguageChange(newLang);
        }
      };

      option.removeEventListener('click', onOptionClick);
      option.addEventListener('click', onOptionClick);
    });

    console.log('✅ SelectLanguageTop event listeners attached.');
  } catch (error) {
    console.error('❌ Error attaching event listeners to SelectLanguageTop:', error);
  }
}

//async function attachEventListenersSelectLanguageTop() {

//    try {

//        let isDropdownOpen = false;

//        const button = document.getElementById("btnSideBarNavDropdown-btn-select-language");
//        if (!button) return;

//        const buttonClone = button.cloneNode(true);
//        button.parentNode.replaceChild(buttonClone, button);

//        // CLICK on  button
//        addListenerViaCurrentlyAttachedListenersRegistry(buttonClone, "click", async () => {

//            //  alert('ggggg');
//            buttonClone.classList.toggle("NewNavSidePanelDropdownActive");
//            var dropdownContent = buttonClone.nextElementSibling;

//            isDropdownOpen = !isDropdownOpen;
//            dropdownContent.style.display = isDropdownOpen ? "block" : "none";

//        });

//        // CLICK on dropdown options

//        const dropdown = buttonClone.nextElementSibling;
//        const options = dropdown.querySelectorAll(".dropbtnSelectSiteLanguage-content-label-mobile");
//        options.forEach(option => {

//            const optionClone = option.cloneNode(true);
//            option.parentNode.replaceChild(optionClone, option);

//            addListenerViaCurrentlyAttachedListenersRegistry(optionClone,"click", async (event) => {
//                const newLang = event.target.value;
//                if (newLang)
//                {
//                  //  alert(newLang);
//                    await applyLanguageChange(newLang);
//                }

//            });
//        }

//        );

//        console.log("✅ SelectLanguageTop event listeners attached.");

//    } catch (error) {
//        console.error("❌ Error attaching event listeners to SelectLanguageTop:", error);
//    }
//}

async function applyLanguageChange(newLang) {
  try {
    // Update language in URL and reload the page
    await updateLanguageInURL(newLang);

    // Update the language label in the UI
    const languageLabel = document.querySelector('.new-language-label');

    if (languageLabel) {
      const newLanguageLabel = await getLanguageLabel(newLang);
      languageLabel.textContent = newLanguageLabel;
    }

    console.log(`🌐 Language changed to: ${newLang}`);
  } catch (err) {
    console.error('❌ Error updating language:', err);
  }
}

async function getLanguageLabel(code) {
  const lang = APP_CONFIG.VALID_LANGUAGES.find(lang => lang.code === code);
  return lang ? lang.name : 'English (UK)';
}
